<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
    >
      <login-card header-color="primary">
        <h4 slot="title" class="title" style="color:white">
          {{ $t("Register") }}
        </h4>
        <md-field
          class="md-form-group"
          slot="inputs"
          :class="[
            { 'md-valid': !errors.has('firstname') && touched.firstname },
            { 'md-error': errors.has('firstname') }
          ]"
        >
          <md-icon>face</md-icon>
          <label>{{ $t("First Name") }}</label>
          <md-input
            name="firstname"
            data-vv-name="firstname"
            v-model="firstname"
            required
            v-validate="'required|min:2'"
            type="text"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('firstname')"
              >close</md-icon
            >
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="!errors.has('firstname') && touched.firstname"
              >done</md-icon
            >
          </slide-y-down-transition>
        </md-field>
        <md-field
          class="md-form-group"
          slot="inputs"
          :class="[
            { 'md-valid': !errors.has('lastname') && touched.lastname },
            { 'md-error': errors.has('lastname') }
          ]"
        >
          <md-icon>face</md-icon>
          <label>{{ $t("Last Name") }}</label>
          <md-input
            name="lastname"
            data-vv-name="lastname"
            v-model="lastname"
            required
            v-validate="'required|min:2'"
            type="text"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('lastname')"
              >close</md-icon
            >
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="!errors.has('lastname') && touched.lastname"
              >done</md-icon
            >
          </slide-y-down-transition>
        </md-field>
        <md-field
          class="md-form-group"
          slot="inputs"
          :class="[
            { 'md-valid': !errors.has('email') && touched.email },
            { 'md-error': errors.has('email') }
          ]"
        >
          <md-icon>email</md-icon>
          <label>{{ $t("Email") }}</label>
          <md-input
            name="email"
            data-vv-name="email"
            v-model="email"
            required
            v-validate="'required|email'"
            type="email"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('email')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="!errors.has('email') && touched.email"
              >done</md-icon
            >
          </slide-y-down-transition>
        </md-field>
        <md-field
          class="md-form-group"
          slot="inputs"
          :class="[
            { 'md-valid': !errors.has('password') && touched.password },
            { 'md-error': errors.has('password') }
          ]"
        >
          <md-icon>lock_outline</md-icon>
          <label>{{ $t("Password") }}</label>
          <md-input
            name="password"
            data-vv-name="password"
            v-model="password"
            required
            v-validate="'required|min:8|verify_password'"
            type="password"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('password')"
              >close</md-icon
            >
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="!errors.has('password') && touched.password"
              >done</md-icon
            >
          </slide-y-down-transition>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>vpn_key</md-icon>
          <label>{{ $t("Invitation Code (Optional)") }}</label>
          <md-input name="code" data-vv-name="code" v-model="code"></md-input>
        </md-field>
        <md-button
          slot="footer"
          class="md-simple md-primary md-lg"
          @click="signup"
          >{{ $t("Get Started") }}</md-button
        >
      </login-card>
      <md-switch v-model="newsletter"
        ><b>{{ $t("Subscribe to Mailing List") }}</b></md-switch
      >
      <br />
      <label v-show="errors.has('password')" class="help is-danger">{{
        errors.first("password")
      }}</label>
      <label class="text-danger">{{ $t(errorMsg) }}</label>
    </div>
  </div>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { LoginCard } from "@/components";
import { EventBus } from "@/helpers";

export default {
  components: {
    LoginCard,
    SlideYDownTransition
  },
  data() {
    return {
      firstname: null,
      lastname: null,
      email: null,
      newsletter: false,
      password: null,
      code: "",
      errorMsg: "",
      touched: {
        firstname: false,
        lastname: false,
        email: false,
        password: false
      }
    };
  },
  watch: {
    firstname() {
      this.touched.firstname = true;
    },
    lastname() {
      this.touched.lastname = true;
    },
    email() {
      this.touched.email = true;
    },
    password() {
      this.touched.password = true;
    }
  },
  methods: {
    signup() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.$store.dispatch("auth/signup", {
            firstname: this.firstname,
            lastname: this.lastname,
            newsletter: this.newsletter,
            email: this.email,
            password: this.password,
            code: this.code
          });
        }
      });
    }
  },
  mounted() {
    EventBus.$on("failedSignup", msg => {
      this.errorMsg = msg;
    });
  },
  beforeDestroy() {
    EventBus.$off("failedSignup");
  }
};
</script>
<style>
@media (max-width: 768px) {
  .modal-mask .modal-container {
    margin: auto;
    max-width: 77%;
  }
}

.modal-container {
  max-width: 500px;
  margin: 0px auto;
  position: relative;
  background-color: #fff;
  transition: all 0.3s ease;
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2),
    0 40px 77px 0 rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  border: none;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 40px 0px 0;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}
</style>
